import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CommonButton from '../../../../components/common/CommonButton';
import AnalysisModal from '../simulatorTasks/AnalysisModal';
import ChartModal from '../simulatorTasks/ChartModal';

const StudentsAssignedModal = ({ isOpen, onClose, simulator }) => {

    const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);
    const [studentSelected, setStudentSelected] = useState(null);
    const [isChartResultsModalOpen, setIsChartResultsModalOpen] = useState(false);

    function parseDate(input) {
        const date = new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    if (!isOpen) return null;
    return (
        <ModalOverlay>
            <ModalBackdrop onClick={onClose} />
            <ModalContainer>
                <ModalHeader>
                    <ModalTitle>
                        Estudiantes que tienen asignado el simulador
                    </ModalTitle>
                    <CloseButton onClick={onClose}>
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </CloseButton>
                </ModalHeader>
                <ModalBody>
                    <table>
                        <thead>
                            <tr>
                                <th>Estudiante</th>
                                <th>Fecha de realización</th>
                                <th>Puntaje obtenido</th>
                                <th>Análisis</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                simulator?.run_codes?.flatMap(runCode =>
                                    runCode.sessions?.map((session) => {

                                        const notCompleted = session?.status !== 'complete';
                                        return (
                                            <>
                                                <AnalysisModal
                                                    isOpen={isAnalysisModalOpen && studentSelected === session?.id}
                                                    onClose={() => setIsAnalysisModalOpen(false)}
                                                    finalAnalysis={session?.final_analysis?.final_analysis}
                                                    onViewChart={() => {
                                                        setStudentSelected(session.id);
                                                        setIsChartResultsModalOpen(true)
                                                    }}
                                                    sessionId={session.id}
                                                />
                                                <ChartModal
                                                    isOpen={isChartResultsModalOpen && studentSelected === session?.id}
                                                    onClose={() => setIsChartResultsModalOpen(false)}
                                                    attributes={session?.final_analysis?.final_analysis?.attributes_scores}
                                                />
                                                <tr key={session?.id}>
                                                    <td>
                                                        <label>
                                                            {session?.user_name}
                                                        </label>
                                                        <p>{session?.user_id}</p>
                                                    </td>
                                                    <td>{notCompleted ? <i>No realizado</i> : parseDate(session?.created_at)}</td>
                                                    <td>{!!session?.final_analysis?.final_analysis?.simulation_score ? `${session?.final_analysis?.final_analysis?.simulation_score} puntos` : "-"}</td>
                                                    <td>
                                                        {
                                                            !notCompleted && (
                                                                <CommonButton
                                                                    label="Ver análisis"
                                                                    variant="text"
                                                                    onClick={() => {
                                                                        setStudentSelected(session.id);
                                                                        setIsAnalysisModalOpen(true)
                                                                    }}
                                                                />
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                )
                            }
                        </tbody>
                    </table>
                </ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default StudentsAssignedModal;

const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
`;

const ModalContainer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 20px 20px 0 20px;
    width: 60vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 0 !important;
    box-shadow: 0px 12px 24px -15px #0000001A, 0px 0px 10px -6px #00000040;

`;

const ModalHeader = styled.div`
    position: relative;
    width: calc(100% - 4rem);
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 1rem;
    padding-left: 3rem;
    border-bottom: 1px solid #e5e7eb;
    background-color: #b31d15;
    border-radius: 20px 20px 0 0;
`;

const ModalTitle = styled.h3`
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
`;

const CloseButton = styled.button`
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #FFF !important;
    background-color: transparent !important;
    border: none;
    padding: 0;
    &:hover {
        color: #6b7280;
    }
    &:focus {
        outline: none;
    }
`;

const ModalBody = styled.div`
    width: calc(100% - 4rem);
    height: 100%;
    max-height: calc(100% - 4rem);
    display: flex;
    align-items: start;
    justify-content: start;
    overflow-y: auto;
    padding: 0 2rem;

    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    thead {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    tbody {
        display: block;
        max-height: calc(90vh - 8rem);
        overflow-y: auto;
        width: 100%;
    }

    tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    th {
        color: #1D1D1B;
        text-align: start;
        padding: 1rem;
        border-bottom: 2px solid #dcdcdc;
        background-color: #fff;
        position: sticky;
        top: 0;
        z-index: 2;
    }

    td {
        height: 42px;
        border-bottom: 2px solid #dcdcdc;
        text-align: start;
        padding: 1rem;
        overflow-wrap: break-word;

        label {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 0.5rem;
        }
    }
`;
